import React, {useContext} from "react"
import {Panel, DataRow} from "../../PDFPrimitives"
import {PDFContext} from "../../BasePDF"

export const PurchaseDealerFinanceDetailsPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    // Optional rows — only render when set and non-zero.
    const optional = [
        // ['Down Payment from Rebate', pdfData.downpayment_from_rebate],
        ['Trade as Cap Reduction',   pdfData.trade_as_cap_reduction],
    ].filter(([, v]) => v && v !== '0')

    // Down Payment and Rebate pull from existing deal data and are
    // shown as negatives. Each row is hidden when its value is 0. Rendering does
    // NOT affect the Total Amount Financed calculation below (which stays exactly
    // as computed by the backend).
    const downPayment = Number(pdfData.cash_due_on_delivery)
    const rebate = Number(pdfData.total_rebates)
    // NJ only. Neither Sales Tax nor Fees includes it; Total Amount Financed does.
    const supplementalTitleFee = pdfData.supplemental_title_fee

    return (
        <Panel title="Finance Details">
            <DataRow label="Total Cash Price" value={pdfData.total_cash_price.toDollarFormat()}/>
            <DataRow
                label={`Sales Tax (${pdfData.tax_rate})`}
                value={pdfData.total_taxes.toDollarFormat()}
            />
            {supplementalTitleFee && (
                <DataRow label={supplementalTitleFee.name} value={supplementalTitleFee.amount.toDollarFormat()}/>
            )}
            <DataRow label="Fees" value={pdfData.total_fees.toDollarFormat()}/>
            {Boolean(downPayment) && (
                <DataRow label="Down Payment" value={(-downPayment).toDollarFormat()}/>
            )}
            {Boolean(rebate) && (
                <DataRow label="Rebate" value={(-rebate).toDollarFormat()}/>
            )}
            {optional.map(([label, v]) => (
                <DataRow key={label} label={label} value={v.toDollarFormat()}/>
            ))}
            <DataRow
                label="Total Amount Financed"
                value={pdfData.amount_financed.toDollarFormat()}
                isTotal
                variant="bold"
            />
            <DataRow label="Finance Charge" value={pdfData.finance_charge.toDollarFormat()}/>
            {pdfData.max_advance && (
                <DataRow label="Max Advance" value={pdfData.max_advance.toDollarFormat()} isLast/>
            )}
        </Panel>
    )
}
